const LOCALE_TO_BCP47 = {
  en: "en",
  sr: "sr-Latn-RS",
  me: "sr-Latn-ME",
  ba: "sr-Latn-BA"
};
function toBcp47(locale) {
  return LOCALE_TO_BCP47[locale] ?? "en";
}
export {
  toBcp47
};
//# sourceMappingURL=index58.js.map
